import * as actionTypes from '../actionTypes';
import axios from '../../../services/axios'
import {setMessage} from "../message";

export const loadDiplomaInfo = () => {
    return {
        type: actionTypes.LOAD_DIPLOMA_INFO
    }
}

export const setDiplomaInfo = (diplomaInfo) => {
    return {
        type: actionTypes.SET_DIPLOMA_INFO,
        diplomaInfo: diplomaInfo
    }
}

export const getDiplomaInfo = () => {
    return (dispatch) => {
        dispatch(loadDiplomaInfo())
        axios.get(`/api/v1/diploma-topic-suggestion/topics`)
            .then( response => {
                dispatch( setDiplomaInfo(response.data))
             } )
             .catch( error => {
                 dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
             } );
    }
}

////////////////////////////////////////////////////////////////

export const loadDiplomaAvailableTopics = () => {
    return {
        type: actionTypes.LOAD_DIPLOMA_AVAILABLE_TOPICS
    }
}

export const setdDiplomaAvailableTopics = (availableTopics) => {
    return {
        type: actionTypes.SET_DIPLOMA_AVAILABLE_TOPICS,
        availableTopics: availableTopics
    }
}

export const getDiplomaAvailableTopics = (employeeId) => {
    return (dispatch) => {
        dispatch(loadDiplomaAvailableTopics())
        axios.get(`/api/v1/diploma-topic-suggestion/employee-topics?employeeId=` + employeeId)
            .then( response => {
                dispatch( setdDiplomaAvailableTopics(response.data))
             } )
             .catch( error => {
                 dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
             } );
    }
}

////////////////////////////////////////////////////////////////

export const sendDiplomaRequest = () => {
    return {
        type: actionTypes.SEND_DIPLOMA_REQUEST
    }
}

export const receiveDiplomaRequestResultOnSuccess = (result) => {
    return {
        type: actionTypes.RECEIVE_DIPLOMA_REQUEST_RESULT_ON_SUCCESS,
        newDiplomaRequest: result
    }
}

export const receiveDiplomaRequestResultOnError = () => {
    return {
        type: actionTypes.RECEIVE_DIPLOMA_REQUEST_RESULT_ON_ERROR
    }
}

export const postDiplomaRequest = (dto) => {
    return (dispatch) => {
        dispatch(sendDiplomaRequest())
        axios.post( `/api/v1/diploma-topic-suggestion/add`, dto)
            .then( response => {
                dispatch(setMessage({type: 'success', text: "Заявка успешно отправлена."}))
                dispatch( receiveDiplomaRequestResultOnSuccess(response.data));
            } )
            .catch( error => {
                dispatch(receiveDiplomaRequestResultOnError());
                dispatch(setMessage({type: "error", text: "Произошла ошибка при отправке заявки."}))
            } );
    }
}

////////////////////////////////////////////////////////////////

export const startDeletingDiplomaRequest = () => {
    return {
        type: actionTypes.DELETE_DIPLOMA_REQUEST
    }
}

export const onDeleteDiplomaRequestSuccess = (requestId) => {
    return {
        type: actionTypes.STOP_DELETING_DIPLOMA_REQUEST_ON_SUCCESS,
        requestId: requestId
    }
}

export const onDeleteDiplomaRequestError = () => {
    return {
        type: actionTypes.STOP_DELETING_DIPLOMA_REQUEST_ON_ERROR
    }
}

export const deleteDiplomaRequest = (requestId) => {
    return (dispatch) => {
        dispatch(startDeletingDiplomaRequest())
        axios.delete( `/api/v1/diploma-topic-suggestion/delete?id=` + requestId)
            .then( response => {
                dispatch( onDeleteDiplomaRequestSuccess(requestId));
            } )
            .catch( error => {
               dispatch(onDeleteDiplomaRequestError());
                dispatch(setMessage({type: "warning", text: "Произошла ошибка при удалении заявки."}))
            } );
    }
}